import axios from 'axios'
import router from '../../router/main'
import user from './user'
import ErrorComponent from "../../components/common/Error"
//import {atob} from 'atob'
//import {decode as Atob/*, encode as Btoa*/} from 'base-64'

const handleError = function (response, commit) {
    if(response.response.data.status === 401) {
        commit('logOut', null);
        router.push({name: 'Login'});
        return false
    } else if (response.name === 'Error') {
        commit('setPopupComponent', ErrorComponent, { root: true });
        commit('switchPopup', true, { root: true });
        return false
    }
};

const state = {
    events: [],
    pastEvents: [],
    terminals: [],
    locations: []
};

const mutations = {
    deleteEvent(state, id){
        state.events = state.events.filter(obj => {
            return obj.id !== id
        });
    },
    setEvents (state, events) {
        if (events.length)
        state.events = events;
    },
    setPastEvents (state, events) {
        if (events.length)
        state.pastEvents = events;
    },
    logOut (user, data) {
        user.token = data;
        user.email = data;
        localStorage.removeItem('user-token');
        localStorage.removeItem('user-email');
    },
    setTerminals(state, terminals) {
        state.terminals = terminals
    },
    setLocations (state, locations) {
        if (locations.length)
            state.locations = locations;
    },
};

const getters = {

};

const actions = {

    loadTerminals({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve, reject) => {
            axios.get('/api/events/terminals', config)
                .then((response) => {
                    if (response.data.success) {
                        commit('setTerminals', response.data.terminals);
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: "Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },


    loadEvents({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve, reject) => {
            commit('setLoading', true, { root: true });
            axios.get('/api/events', config)
                .then((response) => {
                    if (response.data.success) {
                        commit('setEvents', response.data.events);
                        commit('setPastEvents', response.data.pastEvents);
                        commit('setLocations', response.data.locations);
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: "Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                    commit('setFirstLoading', false, { root: true });
                    commit('setLoading', false, { root: true });
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },

    addEvent({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` }
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/events/save', params, config)
                .then((response) => {
                    if (response.data.success) {
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },

    updateEvent({commit}, event) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` }
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/events/update', event, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Event updated",
                            type: "notification1",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: "Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },

    deleteEvent({commit}, id) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/events/delete', {id: id}, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Event canceled",
                            type: "success",
                        } , { root: true });
                        commit('deleteEvent', id);
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: "Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },

    getLocation({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve, reject) => {
            axios.get('/api/events/get-location', config)
                .then((response) => {
                    if (response.data.success) {
                        resolve(response.data.address);
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
};

export default {
    namespaced: true,
    actions,
    getters,
    state,
    mutations
}
